import { createTheme } from '@mui/material/styles';

let theme = createTheme({
  typography: {
    htmlFontSize: 16,
    fontSize: 16,
    fontFamily: [
      "'SF Pro Display'",
      "'SF Pro Text'",
      '-apple-system',
      'BlinkMacSystemFont',
      "'Helvetica Neue'",
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
      lineHeight: 1.05,
      fontSize: 'clamp(2.8rem, 4.5vw + 1rem, 5.5rem)',
      letterSpacing: '-0.035em',
    },
    h2: {
      fontWeight: 700,
      lineHeight: 1.1,
      fontSize: 'clamp(2.2rem, 3.2vw + 0.8rem, 4rem)',
      letterSpacing: '-0.03em',
    },
    h3: {
      fontWeight: 650,
      lineHeight: 1.15,
      fontSize: 'clamp(1.8rem, 2.2vw + 0.6rem, 3rem)',
      letterSpacing: '-0.025em',
    },
    h4: {
      fontWeight: 600,
      lineHeight: 1.2,
      fontSize: 'clamp(1.4rem, 1.5vw + 0.5rem, 2.2rem)',
      letterSpacing: '-0.02em',
    },
    h5: {
      fontWeight: 600,
      lineHeight: 1.25,
      fontSize: 'clamp(1.15rem, 0.9vw + 0.4rem, 1.7rem)',
      letterSpacing: '-0.015em',
    },
    h6: {
      fontWeight: 500,
      lineHeight: 1.3,
      fontSize: 'clamp(1rem, 0.6vw + 0.3rem, 1.4rem)',
      letterSpacing: '-0.01em',
    },
    subtitle1: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontSize: 'clamp(1.05rem, 0.3vw + 0.5rem, 1.25rem)',
      letterSpacing: '0.005em',
      color: 'rgba(0,0,0,0.7)',
    },
    subtitle2: {
      fontWeight: 400,
      lineHeight: 1.45,
      fontSize: 'clamp(0.95rem, 0.2vw + 0.4rem, 1.1rem)',
      letterSpacing: '0.005em',
      color: 'rgba(0,0,0,0.65)',
    },
    body1: {
      fontWeight: 400,
      lineHeight: 1.6,
      fontSize: 'clamp(1rem, 0.3vw + 0.5rem, 1.15rem)',
      letterSpacing: '0.005em',
      color: 'rgba(0,0,0,0.75)',
    },
    body2: {
      fontWeight: 400,
      lineHeight: 1.55,
      fontSize: 'clamp(0.9rem, 0.2vw + 0.4rem, 1rem)',
      letterSpacing: '0.005em',
      color: 'rgba(0,0,0,0.7)',
    },
    button: {
      fontWeight: 500,
      fontSize: 'clamp(0.95rem, 0.25vw + 0.4rem, 1.1rem)',
      letterSpacing: '-0.005em',
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: 'smooth',
          fontSize: '100%',
          WebkitTextSizeAdjust: '100%',
          textSizeAdjust: '100%',
        },
        body: {
          margin: 0,
          fontFamily: [
            "'SF Pro Display'",
            "'SF Pro Text'",
            '-apple-system',
            'BlinkMacSystemFont',
            "'Helvetica Neue'",
            'Helvetica',
            'Arial',
            'sans-serif',
          ].join(','),
          textRendering: 'optimizeLegibility',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundColor: '#f5f5f7',
          color: '#1d1d1f',
        },
        '*': {
          boxSizing: 'border-box',
        },
        '::selection': {
          backgroundColor: 'rgba(25, 181, 148, 0.25)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 980,
          padding: '12px 28px',
          transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            transform: 'scale(1.02)',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '24px !important',
          paddingRight: '24px !important',
          '@media (min-width:600px)': {
            paddingLeft: '32px !important',
            paddingRight: '32px !important',
          },
          '@media (min-width:900px)': {
            paddingLeft: '40px !important',
            paddingRight: '40px !important',
          },
        },
      },
    },
  },
});

export default theme;
